import React, { useContext, useMemo, useCallback } from "react";
import MaterialTable from "material-table";
import tableIcons, { options } from "components/universal/table_attributes";
import { MaintenanceServices } from "lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation";
import { ToastMessageContext } from "lib/contexts/message_context";

const PartDetailsTable = ({ data }) => {
  const message = useContext(ToastMessageContext);

  const workShopOrderId = useMemo(() => data?.id ?? null, [data?.id]);

  const isProjectPart = useMemo(() => data?.project_part, [data?.project_part]);

  const columns = useMemo(
    () => [
      {
        title: "Part #",
        field: "part_number",
        headerStyle: {
          textAlign: "left",
          width: "15%",
          paddingLeft: "15px",
        },
        cellStyle: {
          width: "15%",
          paddingLeft: "15px",
        },
      },

      {
        title: "Description",
        field: "description",
        headerStyle: {
          textAlign: "left",
        },
        cellStyle: {
          textAlign: "left",
        },
      },
      {
        title: "QTY",
        field: "quantity",
        headerStyle: {
          textAlign: "center",
          width: "7%",
        },
        cellStyle: {
          textAlign: "center",
          width: "7%",
        },
      },
      {
        title: "Serial #",
        field: "serial",
        headerStyle: {
          textAlign: "center",
          width: "9%",
        },
        cellStyle: {
          textAlign: "center",
          width: "9%",
        },
      },
      {
        title: "Shelf life",
        field: "shelf_life",
        headerStyle: {
          textAlign: "center",
          width: "9%",
        },
        cellStyle: {
          textAlign: "center",
          width: "9%",
        },
      },
      {
        title: "Location",
        field: "location",
        headerStyle: {
          textAlign: "left",
          width: "11%",
        },
        cellStyle: {
          textAlign: "left",
          width: "11%",
        },
      },
      {
        title: "Batch #",
        field: "batch_number",
        headerStyle: {
          textAlign: "center",
          width: "8%",
        },
        cellStyle: {
          textAlign: "center",
          width: "8%",
        },
      },
    ],
    []
  );

  const fetchData = useCallback(
    (query) =>
      new Promise(async (resolve, reject) => {
        try {
          const params = {
            workshop_order_id: workShopOrderId,
            page: query.page + 1,
            limit: query.pageSize,
          };

          const response = await MaintenanceServices.getStockReceiptPartDetails(
            params
          );

          if (response?.success) {
            const total = response.total_count || 0;
            const page = response.current_page - 1;

            resolve({
              data: response.data || [],
              page: total === 0 ? 0 : page,
              totalCount: total,
            });
          } else {
            setTimeout(() => {
              message.showToastMessage({
                message: "Failed to fetch part details",
                variant: "error",
              });
            }, 0);
            reject("Fetch failed");
          }
        } catch (err) {
          setTimeout(() => {
            message.showToastMessage({
              message: "Something went wrong. Try again!",
              variant: "error",
            });
          }, 0);
          reject("API Error");
        }
      }),
    [workShopOrderId, message]
  );

  const tableOptions = {
    ...options,
    paging: isProjectPart,
    search: false,
    toolbar: false,
    pageSize: 10,
    pageSizeOptions: [5, 10, 20, 30, 50],
    maxBodyHeight: 500,
  };

  console.log(workShopOrderId, "work shop order id");
  const tableStyle = { boxShadow: "0px 1px 3px #00000033" };

  if (!workShopOrderId) return null;

  return (
    <MaterialTable
      style={tableStyle}
      title=""
      columns={columns}
      data={fetchData}
      options={tableOptions}
      icons={tableIcons}
      localization={{
        body: {
          emptyDataSourceMessage: "No Records found",
        },
      }}
    />
  );
};

export default PartDetailsTable;
